import { Config } from "@/hooks/useConfig";
import { Layer } from "@/Utils/hierarchy";

export const content = {
  title: "Channel ROI",
  subtitle:
    "See your total Return on Investment from marketing and compare the efficiency and effectiveness of each channel. This is a great place to start planning how to improve future performance.",
};

export const getMetricHeadings = (config: Config, funnelStage: string) => {
  let funnelStageLabel = config.getLayerLabel(funnelStage as Layer);
  funnelStageLabel = funnelStageLabel === "all" ? "Aggregate" : funnelStageLabel;
  const { revenueLabel } = config;
  return {
    MARKETING_SPEND: `${funnelStageLabel} Marketing Spend`,
    MARKETING_REVENUE: `${funnelStageLabel} Marketing ${revenueLabel}`,
    MARKETING_ROI: `${funnelStageLabel} Marketing ROI`,
    MARKETING_YIELD: `${funnelStageLabel} Marketing Yield`,
    PRODUCT_MARKETING_SPEND: `${config.getLayerLabel(Layer.Product)} Marketing Spend`,
    PRODUCT_MARKETING_REVENUE: `${config.getLayerLabel(Layer.Product)} Marketing ${revenueLabel}`,
    CATEGORY_MARKETING_REVENUE: `${config.getLayerLabel(Layer.Category)} Marketing ${revenueLabel}`,
    CATEGORY_MARKETING_SOE: `${config.getLayerLabel(Layer.Category)} Marketing Share of Effect`,
    BRAND_MARKETING_REVENUE: `${config.getLayerLabel(Layer.Brand)} Marketing ${revenueLabel}`,
    BRAND_MARKETING_SOE: `${config.getLayerLabel(Layer.Brand)} Marketing Share of Effect`,
  };
};

export const getMarketingContributionTooltip = (config: Config, funnelStage: string) =>
  `The percentage of this product's total revenue attributed to the halo effect of ${config.getLayerLabel(funnelStage as Layer).toLowerCase()} marketing`;

export const adStockToolTipContent = `Ad Stock weeks represent the time it takes for your ads to reach peak impact (Peak Effect Point) and how long their influence lasts (Length of Effect).`;

export const noDataContent = {
  title: "Insufficient Data",
  description:
    "Sorry, there is not enough data to show this module. Try selecting a difference business unit or adjusting your date range.",
};
